import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
    nameCellContent: {
        alignItems: 'center',
        display: 'flex',
        paddingLeft: 0
    },
    userIcon: {
        color: theme.palette.grey.semidark
    },
    accountModulesCellContent: {
        display: 'flex'
    },
    cell: {
        paddingTop: '8px',
        paddingBottom: '8px',
    }
}));
